import { useQuery } from '@gogame/query';

import { loadNewsList } from '../sources/news';
import { grid } from './queryKeyFactory';

//TODO: prefetch function for data
export const useLoadNews = (type) => {
  return useQuery(grid(type), (_, { signal }) =>
    loadNewsList({ type }, { signal })
  );
};
